module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-4"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(_vm.isInformationModalVisible) ? _c('information', [_c('template', {
    slot: "header"
  }, [_c('div', {
    staticClass: "alert alert-warning d-flex align-items-center justify-content-center text-center",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', [_c('strong', [_vm._v("Thanks for registering to invest in communities with us!\n                      For security purposes, additional information is required to verify your identity.")])])])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-accept",
    on: {
      "click": _vm.beginKba
    }
  }, [_vm._v("Start questionnaire")])])])])], 2) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "card-title mb-3"
  }, [_vm._v("Identity Verification")]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.successMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-start mb-3"
  }, [_c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("About")]), _vm._v(" "), _c('div', {
    staticClass: "h5 friendly-timer"
  }, [_c('span', {
    staticClass: "badge badge-info"
  }, [_vm._v(_vm._s(_vm.formattedTime))])])])]), _vm._v(" "), _c('dismissable-alert', {
    staticClass: "mb-3",
    attrs: {
      "isShowing": true,
      "dismissible": false,
      "alertType": "success",
      "showIcon": true,
      "icon": "information",
      "title": "About these questions",
      "subtitle": "We do not store your questions or answers. They are provided by our verification partner from publicly available government records."
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "text-center my-4"
  }, [_c('div', {
    staticClass: "spinner-border text-info",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small text-muted mt-2"
  }, [_vm._v("Loading questions…")])]) : _vm._e(), _vm._v(" "), (_vm.questions.length) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._l((_vm.questions), function(q, qi) {
    return _c('div', {
      key: q.id,
      staticClass: "card mb-4 question-card shadow-sm",
      attrs: {
        "aria-labelledby": ("q-" + (q.id) + "-label")
      }
    }, [_c('div', {
      staticClass: "card-header d-flex justify-content-between align-items-center"
    }, [_c('strong', [_vm._v("Question " + _vm._s(qi + 1))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Select one")])]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "question-text mb-3",
      attrs: {
        "id": ("q-" + (q.id) + "-label")
      }
    }, [_vm._v(_vm._s(q.text))]), _vm._v(" "), _c('div', {
      staticClass: "answers"
    }, _vm._l((q.answers), function(ans) {
      return _c('div', {
        key: ans.id,
        staticClass: "answer-item mb-2 p-2 border rounded"
      }, [_c('div', {
        staticClass: "custom-control custom-radio"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedAnswers[q.id]),
          expression: "selectedAnswers[q.id]"
        }],
        staticClass: "custom-control-input",
        attrs: {
          "type": "radio",
          "name": ("q-" + (q.id)),
          "id": ("q-" + (q.id) + "-a-" + (ans.id)),
          "disabled": _vm.submitting || _vm.loading || _vm.expired
        },
        domProps: {
          "value": ans.id,
          "checked": _vm._q(_vm.selectedAnswers[q.id], ans.id)
        },
        on: {
          "__c": function($event) {
            _vm.$set(_vm.selectedAnswers, q.id, ans.id)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "custom-control-label",
        attrs: {
          "for": ("q-" + (q.id) + "-a-" + (ans.id))
        }
      }, [_vm._v("\n                        " + _vm._s(ans.text) + "\n                      ")])])])
    }))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isComplete || _vm.submitting || _vm.expired
    }
  }, [_vm._v("\n                Submit Answers\n              ")]), _vm._v(" "), (_vm.expired) ? _c('span', {
    staticClass: "text-danger ml-3"
  }, [_vm._v("Session expired.")]) : _vm._e()])], 2) : _vm._e()], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e49c9b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KbaVerification.vue
// module id = 2131
// module chunks = 1